import React, { useEffect, useState } from 'react'

const PageLoad = ({ loading }) => {

  const [show, setShow] = useState(loading);

  useEffect(() => {
    let timer;

    if (loading) {
      setShow(true);
    } else {
      timer = setTimeout(() => {
        setShow(false);
      }, 1000);
    }

    document.body.style.overflow = loading ? "hidden" : "auto";

    return () => clearTimeout(timer);
  }, [loading]);

  if (!show) return null;

  return (
    <div className={`loader-wrapper ${!loading ? "opacity-0" : "opacity-100"} ease transition-opacity duration-[1s]`}>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"> </div>
      <div className="dot"></div>
    </div>

  )
}

export default PageLoad